import { gql } from '@apollo/client';

export const ADD_AIR_PRODUCT_EXECUTION = gql`
  mutation AirProductAddProductExecution(
    $productId: ID!
    $user: String
    $executionData: ProductExecutionInput
  ) {
    airProductAddProductExecution(
      productId: $productId
      user: $user
      executionData: $executionData
    ) {
      executions {
        status
        reportUrl
        executionStatus
        name
        createDate
        endDate
        testName
        user
      }
    }
  }
`;

export const REMOVE_AIR_PRODUCT_EXECUTION = gql`
  mutation AirProductRemoveExecutionFromAirProduct(
    $productId: ID!
    $executions: [String!]
  ) {
    airProductRemoveExecutionFromAirProduct(
      productId: $productId
      executions: $executions
    ) {
      executions {
        name
        user
      }
    }
  }
`;
